export const TOGGLE_MODAL = 'CLOSING_LESSON_MODAL.TOGGLE_MODAL';
export const CONFIRM_LESSON_CLOSING = 'CLOSING_LESSON_MODAL.CONFIRM_LESSON_CLOSING';
export const CANCEL_LESSON_CLOSING = 'CLOSING_LESSON_MODAL.CANCEL_LESSON_CLOSING';
